/** @format */

import { FunctionComponent as FC, useContext, useState } from 'react';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import styled, { ThemeContext } from 'styled-components';
import Search from '../../../assets/icons/search.svg';
import { Icon } from '../Icon';
import { Error } from './Error';
import { FormControl } from './FormControl';

export const Input: FC<Props<FieldValues>> = ({
  name,
  register,
  errors,
  required,
  label,
  variant = 'light',
  type,
  search,
  onChange,
  onBlur,
  pattern,
  autocomplete = 'off',
  children,
  value,
}) => {
  const theme = useContext(ThemeContext);
  const [inputValue, setInputValue] = useState<string | boolean>('');

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.type === 'checkbox' ? e.target.checked : e.target.value);
    onChange && onChange(e);
    onBlur && onBlur(e);
  };

  return (
    <>
      <FormControl $filled={inputValue !== ''} $variant={variant} $type={type}>
        {label && <label htmlFor={name} dangerouslySetInnerHTML={{ __html: label }} />}
        <StyledInput
          id={name}
          {...register(name, { required, onChange: e => onInputChange(e), onBlur: e => onInputChange(e), pattern })}
          type={type}
          aria-invalid={errors[name] ? 'true' : 'false'}
          autoComplete={autocomplete}
          className={errors[name] ? 'error' : ''}
          value={value}
        />
        {search && <Icon icon={Search} width={13} height={13} color={theme?.color.teal.light} />}
        {children ?? ''}
      </FormControl>
      {errors[name] && <Error type={type} message={String(errors[name]?.message) ?? 'error'} />}
    </>
  );
};

type Props<T extends FieldValues> = {
  variant?: 'light' | 'dark';
  name: keyof T;
  label: string;
  register: UseFormRegister<T>;
  errors: FieldErrors<T>;
  required?: boolean | string;
  type?: React.HTMLInputTypeAttribute;
  search?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.ChangeEventHandler<HTMLInputElement>;
  pattern?: {
    value: RegExp;
    message: string;
  };
  autocomplete?: 'off' | 'on';
  children?: React.ReactNode;
  value?: string;
};

const StyledInput = styled.input`
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  /* &[type='radio'] {
    width: 1rem;
    height: 1rem;
    accent-color: ${({ theme }) => theme.color.pink};
  } */

  &[type='checkbox'] {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 1.5rem;
    height: 1.5rem;
    accent-color: ${({ theme }) => theme.color.teal.dark};
  }
  &[type='radio'] {
    padding: 0.75rem 0.94rem;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 1.5rem;
    height: 1.5rem;
    accent-color: ${({ theme }) => theme.color.teal.dark};
    outline-offset: 0px !important;
  }
`;
